<template>
<div class="project">
  <div class="view">
    <button :class="[ user_type === 'all' ? 'selected item_button' : 'item_button']" @click="update_source('all')">All</button>
    <button :class="[ user_type === 'BOJ' ? 'selected item_button' : 'item_button']" @click="update_source('BOJ')">BOJ</button>
    <button :class="[ user_type === 'SWexpert' ? 'selected item_button' : 'item_button']" @click="update_source('SWexpert')">SWexpert</button>
    <button :class="[ user_type === 'Programmers' ? 'selected item_button' : 'item_button']" @click="update_source('Programmers')">Programmers</button>

    <br>
    <div class="checks etrans">
      <input type="checkbox" id="ex_chk3" @click="onCheck">
      <label for="ex_chk3">간단히 보기</label>
    </div>

    <div v-if="user_type == 'all'">
      <div v-for="item in Algorithm">
        <!-- 간단히 보기 눌렀을 때-->
        <div v-if="check">
          <div v-if="item.site === 'Programmers'" class="item pro" >
            <span id="simple_type">{{item.site}}</span>
            <span id="simple_name">{{item.name}}</span>
            <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
          </div>
          <div v-else-if="item.site === 'SWexpert'" class="item swe" >
            <span id="simple_type">{{item.site}}</span>
            <span id="simple_name">{{item.name}}</span>
            <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
          </div>
          <div v-else-if="item.site === 'BOJ'" class="item boj" >
            <span id="simple_type">{{item.site}}</span>
            <span id="simple_name">{{item.name}}</span>
            <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
          </div>
        </div>

        <!-- 간단히 보기 아닐때 -->
        <div v-else>
          <div v-if="item.site === 'Programmers'" class="item pro" >
            <div class="item_title">{{ item.name }}
              <div>{{item.site}} {{item.number}}</div>
            </div>
            <div><strong class="item_disc">{{ item.disc }}</strong></div>
            <div>{{item.type}}</div>
            <div>{{item.date}}</div>
            <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
          </div>

          <div v-else-if="item.site === 'SWexpert'" class="item swe" >
            <div class="item_title">{{ item.name }}
              <div>{{item.site}} {{item.number}}</div>
            </div>
            <div><strong class="item_disc">{{ item.disc }}</strong></div>
            <div>{{item.type}}</div>
            <div>{{item.date}}</div>
            <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
          </div>

          <div v-else-if="item.site === 'BOJ'" class="item boj" >
            <div class="item_title">{{ item.name }}
              <div>{{item.site}} {{item.number}}</div>
            </div>
            <div><strong class="item_disc">{{ item.disc }}</strong></div>
            <div>{{item.type}}</div>
            <div>{{item.date}}</div>
            <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
          </div>

        </div>

      </div>
    </div>

    <div v-else-if="user_type =='BOJ'">
      <div class="" v-for="item in Algorithm" v-if="item.site =='BOJ'">

        <div :class="[ item.site === 'BOJ' ? 'item boj' : 'item swe']" v-if="check">
          <span id="simple_type">{{item.site}}</span>
          <span id="simple_name">{{item.name}}</span>
          <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
        </div>

        <div v-else>
          <div class="item boj">
            <div class="item_title">{{ item.name }}
              <div>{{item.site}} {{item.number}}</div>
            </div>
            <div><strong class="item_disc">{{ item.disc }}</strong></div>
            <div>{{item.type}}</div>
            <div>{{item.date}}</div>
            <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="user_type =='SWexpert'">
      <div class="" v-for="item in Algorithm" v-if="item.site =='SWexpert'">

        <div :class="[ item.site === 'BOJ' ? 'item boj' : 'item swe']" v-if="check">
          <span id="simple_type">{{item.site}}</span>
          <span id="simple_name">{{item.name}}</span>
          <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
        </div>

        <div v-else>
          <div class="item swe">
            <div class="item_title">{{ item.name }}
              <div>{{item.site}} {{item.number}}</div>
            </div>

            <div><strong class="item_disc">{{ item.disc }}</strong></div>
            <div>{{item.type}}</div>
            <div>{{item.date}}</div>
            <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
          </div>
        </div>
      </div>
    </div>

  <div v-else-if="user_type =='Programmers'">
    <div class="" v-for="item in Algorithm" v-if="item.site =='Programmers'">

      <div :class="[ item.site === 'Programmers' ? 'item pro' : 'item swe']" v-if="check">
        <span id="simple_type">{{item.site}}</span>
        <span id="simple_name">{{item.name}}</span>
        <span class="simple_link" @click="onClick(item.link)"> 풀이보기</span>
      </div>

      <div v-else>
        <div class="item pro">
          <div class="item_title">{{ item.name }}
            <div>{{item.site}} {{item.number}}</div>
          </div>

          <div><strong class="item_disc">{{ item.disc }}</strong></div>
          <div>{{item.type}}</div>
          <div>{{item.date}}</div>
          <button class="fun-btn" @click="onClick(item.link)">풀이보기</button>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>
import Algorithm from '@/models/Algorithm.js'

export default {
  data() {
    return {
      Algorithm: Algorithm,
      user_type: 'all',
      check: false,
    }
  },
  components: {},
  methods: {
    update_source(user_type) {
      this.user_type = user_type;
    },
    onClick(url) {
      window.open(url)
    },
    onCheck() {
      this.check = !this.check;
    }
  }

}
</script>

<style>
@font-face {
  font-family: 'ymB';
  src: url("../assets/font/ymB.ttf") format('truetype')
}

@font-face {
  font-family: 'ymL';
  src: url("../assets/font/ymL.ttf") format('truetype')
}

.item_title div {
  font-size: 15px;
  color: gray;
}

.fun-btn {
  padding: 0 0 0 0;
  text-align: center;
  margin-top: 10px;
}

@-webkit-keyframes sheen {
  0% {
    -webkit-transform: skewY(-45deg) translateX(0);
    transform: skewY(-45deg) translateX(0);
  }

  100% {
    -webkit-transform: skewY(-45deg) translateX(12.5em);
    transform: skewY(-45deg) translateX(12.5em);
  }
}

@keyframes sheen {
  0% {
    -webkit-transform: skewY(-45deg) translateX(0);
    transform: skewY(-45deg) translateX(0);
  }

  100% {
    -webkit-transform: skewY(-45deg) translateX(12.5em);
    transform: skewY(-45deg) translateX(12.5em);
  }
}


.item_button {
  margin-left: 6px;
  margin-top: 10px;
  padding: 0.25em 1.5em;
  text-align: center;
  text-decoration: none;
  color: #2194E0;
  border: 2px solid #2194E0;
  font-size: 24px;
  display: inline-block;
  border-radius: 0.3em;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
}

.item_button:before {
  content: "";
  background-color: rgba(255, 255, 255, 0.5);
  height: 100%;
  width: 3em;
  display: block;
  position: absolute;
  top: 0;
  left: -4.5em;
  -webkit-transform: skewX(-45deg) translateX(0);
  transform: skewX(-45deg) translateX(0);
  transition: none;
}

.item_button:hover {
  background-color: #2194E0;
  color: #fff;
  border-bottom: 4px solid #1977b5;
}

.item_button:hover:before {
  -webkit-transform: skewX(-45deg) translateX(13.5em);
  transform: skewX(-45deg) translateX(13.5em);
  transition: all 0.5s ease-in-out;
}

#simple_type {
  float: left;
  font-family: 'ymB';
  margin-left: 50px;
}

#simple_name {
  text-align: center;
  font-family: 'ymL';
  font-weight: bold;
  font-size: 1rem;
  color: blue;
}



.simple_link {
  /* change bg color to get different hues    */
  float: right;
  background-color: salmon;
  color: white;
  padding: 0.2em 1em;
  border: none;
  transition: all .3s ease;
  border-radius: 5px;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  align-self: center;
  cursor: pointer;
  font-weight: bold;
  margin-right: 10px;
}

.simple_link:hover {
  animation: random-bg .5s linear infinite, grow 1300ms ease infinite;
}

.start-simple_link {
  background-color: #fff !important;
  /* change color of button text when fun is started   */
  color: salmon !important;
}

/* pulsating effect on button */
@keyframes grow {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
}

.checks {
  margin-top: 15px;
  position: relative;
  display: inline-block;
  margin-left: 30px;
}

.checks input[type="checkbox"] {  /* 실제 체크박스는 화면에서 숨김 */
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip:rect(0,0,0,0);
  border: 0
}
.checks input[type="checkbox"] + label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.checks input[type="checkbox"] + label:before {  /* 가짜 체크박스 */
  content: ' ';
  display: inline-block;
  width: 21px;  /* 체크박스의 너비를 지정 */
  height: 21px;  /* 체크박스의 높이를 지정 */
  line-height: 21px; /* 세로정렬을 위해 높이값과 일치 */
  margin: -2px 8px 0 0;
  text-align: center;
  vertical-align: middle;
  background: #fafafa;
  border: 1px solid #cacece;
  border-radius : 3px;
  box-shadow: 0px 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
}
.checks input[type="checkbox"] + label:active:before,
.checks input[type="checkbox"]:checked + label:active:before {
  box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
}

.checks input[type="checkbox"]:checked + label:before {  /* 체크박스를 체크했을때 */
  content: '\2714';  /* 체크표시 유니코드 사용 */
  color: #99a1a7;
  text-shadow: 1px 1px #fff;
  background: #e9ecee;
  border-color: #adb8c0;
  box-shadow: 0px 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
}

.checks.small input[type="checkbox"] + label {
  font-size: 12px;
}

.checks.small input[type="checkbox"] + label:before {
  width: 17px;
  height: 17px;
  line-height: 17px;
  font-size: 11px;
}

.checks.etrans input[type="checkbox"] + label {
  padding-left: 30px;
}
.checks.etrans input[type="checkbox"] + label:before {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 0;
  opacity: .6;
  box-shadow: none;
  border-color: #6cc0e5;
  -webkit-transition: all .12s, border-color .08s;
  transition: all .12s, border-color .08s;
}

.checks.etrans input[type="checkbox"]:checked + label:before {
  position: absolute;
  content: "";
  width: 10px;
  top: -5px;
  left: 5px;
  border-radius: 0;
  opacity:1;
  background: transparent;
  border-color:transparent #6cc0e5 #6cc0e5 transparent;
  border-top-color:transparent;
  border-left-color:transparent;
  -ms-transform:rotate(45deg);
  -webkit-transform:rotate(45deg);
  transform:rotate(45deg);
}

.no-csstransforms .checks.etrans input[type="checkbox"]:checked + label:before {
  /*content:"\2713";*/
  content: "\2714";
  top: 0;
  left: 0;
  width: 21px;
  line-height: 21px;
  color: #6cc0e5;
  text-align: center;
  border: 1px solid #6cc0e5;
}




</style>
<style scoped>
.fun-btn {
  /* change bg color to get different hues    */
  background-color: salmon;
  color: white;
  padding: 0.2em 1em;
  border: none;
  transition: all .3s ease;
  border-radius: 5px;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  align-self: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
}

.fun-btn:hover {
  animation: random-bg .5s linear infinite, grow 1300ms ease infinite;
}

.start-fun {
  background-color: #fff !important;
  /* change color of button text when fun is started   */
  color: salmon !important;
}
</style>
